import { defineComponent, createElementBlock, openBlock, createBlock, createCommentVNode, withCtx, Fragment, renderList, createVNode } from 'vue';
import _sfc_main$1 from './basler-components.es218.js';
/* empty css                        */
import _sfc_main$2 from './basler-components.es99.js';
import _sfc_main$3 from './basler-components.es104.js';
/* empty css                        */

const _hoisted_1 = { class: "tabs-media-block" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TabsMediaBlock",
  props: {
    title: {},
    items: {},
    tabsPositon: { default: "left" },
    tabListHorizontalWidth: {},
    state: {}
  },
  emits: ["tab-change"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        _ctx.items ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          title: _ctx.title,
          "tab-list-position": _ctx.tabsPositon,
          "tab-list-horizontal-width": _ctx.tabListHorizontalWidth,
          state: _ctx.state,
          onTabChange: _cache[0] || (_cache[0] = ($event) => emit("tab-change", $event))
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item) => {
              return openBlock(), createBlock(_sfc_main$2, {
                key: item.title,
                uid: item.uid,
                title: item.title,
                subtitle: item?.subtitle,
                imgSrc: item?.imgSrc,
                icon: item?.icon,
                "active-on-init": item?.activeOnInit
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$3, {
                    media: item.media,
                    class: "tabs-media-block__media",
                    cols: [6, 6, 6],
                    lazyload: item.lazyload == null ? true : item.lazyload
                  }, null, 8, ["media", "lazyload"])
                ]),
                _: 2
              }, 1032, ["uid", "title", "subtitle", "imgSrc", "icon", "active-on-init"]);
            }), 128))
          ]),
          _: 1
        }, 8, ["title", "tab-list-position", "tab-list-horizontal-width", "state"])) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as default };
